import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SvgIcon from '../SvgIcon';

var GooglePlaySmall = function GooglePlaySmall(props) {
  return _jsxs(SvgIcon, __assign({}, props, {
    children: [_jsx("path", {
      d: "M2.48848 23.5598L2.4209 23.4935C2.15625 23.2062 2 22.7601 2 22.1824V22.3183V1.6819C2 1.68003 2 1.67863 2 1.67714C2 1.67892 2 1.68041 2 1.68227V1.8186C2 1.19305 2.18217 0.721836 2.48739 0.439293L13.7556 11.9999L2.48848 23.5598ZM2 1.67602C2 1.62461 2.00136 1.57469 2.00391 1.52551C2.00136 1.57431 2 1.62461 2 1.67602ZM2.00391 1.52328C2.00391 1.52262 2.00391 1.52188 2.00418 1.52113C2.00391 1.52188 2.00391 1.52262 2.00391 1.52328ZM2.00418 1.51674C2.00418 1.51637 2.00418 1.516 2.00418 1.51562C2.00418 1.516 2.00418 1.51637 2.00418 1.51674Z",
      fill: "url(#paint0_linear_3678_152)"
    }), _jsx("path", {
      d: "M17.5111 15.9915L17.5968 15.9415L22.0468 13.3474C22.471 13.1 22.7538 12.8 22.8948 12.4825C22.7541 12.8 22.4713 13.1003 22.0468 13.3478L17.5968 15.9419L17.5111 15.9915ZM17.5122 15.8548L13.7556 11.9999L17.5118 8.14577L22.0468 10.7891C22.6226 11.1248 22.946 11.5575 23 11.9996C23 11.9999 23 12.0007 23 12.0013C22.946 12.4424 22.6226 12.8755 22.0468 13.2111L17.5122 15.8548Z",
      fill: "url(#paint1_linear_3678_152)"
    }), _jsx("path", {
      d: "M3.29185 24C2.97708 24 2.70242 23.895 2.48824 23.6967L2.4886 23.6964C2.70278 23.8947 2.97781 24 3.29258 24C3.31986 24 3.3476 23.9993 3.3757 23.9979C3.34724 23.9993 3.31913 24 3.29185 24ZM3.29222 23.8633C2.97745 23.8637 2.70278 23.7583 2.4886 23.56V23.5598L13.7557 11.9999L17.5123 15.8547L4.3111 23.5502C3.94585 23.7627 3.5998 23.8633 3.29222 23.8633ZM2.48542 23.6942C2.4655 23.6757 2.44595 23.656 2.42676 23.6355L2.48542 23.6942Z",
      fill: "url(#paint2_linear_3678_152)"
    }), _jsx("path", {
      d: "M13.7555 11.9999L2.4873 0.439245C2.70149 0.241335 2.97578 0.136361 3.29019 0.136361C3.59859 0.136361 3.94492 0.237323 4.31089 0.450163L17.5117 8.14571L13.7555 11.9999ZM17.5967 8.05865L4.31089 0.313928C3.94492 0.100995 3.59859 3.52859e-05 3.29019 3.52859e-05C3.28873 3.52859e-05 3.28773 3.52859e-05 3.28628 3.52859e-05C3.2881 3.52859e-05 3.28946 3.52859e-05 3.29164 3.52859e-05C3.59932 3.52859e-05 3.94528 0.100622 4.31089 0.313555L17.5967 8.05865Z",
      fill: "url(#paint3_linear_3678_152)"
    }), _jsx("path", {
      d: "M3.37558 23.9978C3.66151 23.981 3.9781 23.88 4.31097 23.6865L17.5111 15.9913L4.31097 23.6865C3.97837 23.8804 3.66151 23.981 3.37558 23.9978ZM2.48811 23.6967L2.48529 23.6942C2.48629 23.6949 2.48738 23.6959 2.48811 23.6967ZM2.42663 23.6355L2.4209 23.6297V23.6293C2.42308 23.6315 2.42481 23.6336 2.42663 23.6355Z",
      fill: "black"
    }), _jsx("path", {
      d: "M17.5112 15.9915L17.5969 15.9421L17.5112 15.9915Z",
      fill: "url(#paint4_linear_3678_152)"
    }), _jsx("path", {
      d: "M3.29245 24C2.97768 24 2.70265 23.8947 2.48847 23.6964L2.48811 23.6967C2.48738 23.696 2.48629 23.695 2.48529 23.6942L2.42663 23.6355C2.42481 23.6337 2.42308 23.6315 2.4209 23.6294L2.48847 23.56C2.70265 23.7583 2.97732 23.8637 3.29209 23.8633C3.59967 23.8633 3.94572 23.7627 4.31097 23.5502L17.5122 15.8547L17.5968 15.9415L17.5111 15.9914L4.31097 23.6866C3.9781 23.8801 3.66151 23.9811 3.37558 23.9979C3.34747 23.9993 3.31973 24 3.29245 24Z",
      fill: "url(#paint5_linear_3678_152)"
    }), _jsx("path", {
      d: "M2.4209 23.6298C2.15625 23.3425 2 22.8963 2 22.3187V22.3183C2 22.8963 2.15625 23.3421 2.4209 23.6294V23.6298Z",
      fill: "black"
    }), _jsx("path", {
      d: "M2.4209 23.6294C2.15625 23.3421 2 22.8964 2 22.3183V22.1823C2 22.76 2.15625 23.2061 2.4209 23.4934L2.48848 23.5598L2.4209 23.6294Z",
      fill: "url(#paint6_linear_3678_152)"
    }), _jsx("path", {
      d: "M2.4209 23.6294L2.48938 23.5606V23.5609L2.4209 23.6294Z",
      fill: "url(#paint7_linear_3678_152)"
    }), _jsx("path", {
      d: "M22.8948 12.4824C22.9647 12.3249 22.9999 12.1631 22.9999 12.0012C22.9999 12.0009 22.9999 12.0006 22.9999 12.0006C22.9999 12.1627 22.9647 12.3245 22.8948 12.4824Z",
      fill: "black"
    }), _jsx("path", {
      d: "M17.5968 15.9415L17.5122 15.8548L22.0468 13.2111C22.6226 12.8755 22.946 12.4424 23 12.0013C23 12.1632 22.9648 12.325 22.8948 12.4825C22.7538 12.8 22.471 13.1 22.0468 13.3474L17.5968 15.9415Z",
      fill: "url(#paint8_linear_3678_152)"
    }), _jsx("path", {
      d: "M23 11.9999V11.9995C22.9996 11.5114 22.6817 11.0234 22.0468 10.653L17.5968 8.05893H17.5964L17.5968 8.05865L22.0468 10.6527C22.6824 11.023 23.0007 11.5118 23 11.9999Z",
      fill: "#404040"
    }), _jsx("path", {
      d: "M22.9999 11.9995C22.9458 11.5574 22.6225 11.1247 22.0466 10.789L17.5117 8.14572L17.5963 8.05894H17.5967L22.0466 10.653C22.6815 11.0234 22.9995 11.5114 22.9999 11.9995Z",
      fill: "url(#paint9_linear_3678_152)"
    }), _jsx("path", {
      d: "M2 1.67712C2 1.67675 2 1.67638 2 1.676C2 1.67638 2 1.67675 2 1.67712ZM2.00391 1.5255C2.00391 1.52475 2.00391 1.524 2.00391 1.52326C2.00391 1.524 2.00391 1.52475 2.00391 1.5255ZM2.00418 1.52111C2.00418 1.51962 2.00418 1.51822 2.00418 1.51672C2.00418 1.51822 2.00418 1.51962 2.00418 1.52111ZM2.00418 1.51561C2.05684 0.557033 2.56487 0.0033313 3.28354 6.55651e-05C2.97196 0.00193167 2.70057 0.106905 2.48811 0.303323V0.30295L2.48557 0.305561C2.46319 0.326276 2.44191 0.348204 2.4209 0.370785C2.18217 0.629907 2.03156 1.01808 2.00418 1.51561Z",
      fill: "#404040"
    }), _jsx("path", {
      d: "M2 1.8186V1.68228C2 1.68041 2 1.67892 2 1.67715C2 1.67677 2 1.6764 2 1.67603C2 1.62461 2.00136 1.57432 2.00391 1.52552C2.00391 1.52477 2.00391 1.52403 2.00391 1.52328C2.00391 1.52263 2.00391 1.52188 2.00418 1.52113C2.00418 1.51964 2.00418 1.51824 2.00418 1.51675C2.00418 1.51637 2.00418 1.516 2.00418 1.51563C2.03156 1.0181 2.18217 0.629929 2.4209 0.370807L2.48739 0.439298C2.18217 0.72184 2 1.19305 2 1.8186ZM2.48557 0.305583L2.48811 0.302972C2.48739 0.304092 2.4863 0.304837 2.48557 0.305583Z",
      fill: "url(#paint10_linear_3678_152)"
    }), _jsx("path", {
      d: "M17.5118 8.14575L4.31097 0.450202C3.945 0.237362 3.59867 0.1364 3.29027 0.1364C2.97586 0.1364 2.70156 0.241374 2.48738 0.439284L2.4209 0.370794C2.44191 0.348213 2.46319 0.326285 2.48556 0.30557C2.48629 0.304823 2.48738 0.304078 2.48811 0.303332C2.70056 0.106915 2.97195 0.00194073 3.28354 7.43866e-05C3.28426 7.43866e-05 3.28526 7.43866e-05 3.28636 7.43866e-05C3.28781 7.43866e-05 3.28881 7.43866e-05 3.29027 7.43866e-05C3.59867 7.43866e-05 3.945 0.101034 4.31097 0.313968L17.5968 8.05869L17.5964 8.05897L17.5118 8.14575Z",
      fill: "url(#paint11_linear_3678_152)"
    }), _jsxs("defs", {
      children: [_jsxs("linearGradient", __assign({
        id: "paint0_linear_3678_152",
        x1: "12.7565",
        y1: "1.46421",
        x2: "-2.89814",
        y2: "16.7225",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#00A0FF"
        }), _jsx("stop", {
          offset: "0.00657445",
          stopColor: "#00A1FF"
        }), _jsx("stop", {
          offset: "0.2601",
          stopColor: "#00BEFF"
        }), _jsx("stop", {
          offset: "0.5122",
          stopColor: "#00D2FF"
        }), _jsx("stop", {
          offset: "0.7604",
          stopColor: "#00DFFF"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#00E3FF"
        })]
      })), _jsxs("linearGradient", __assign({
        id: "paint1_linear_3678_152",
        x1: "23.7016",
        y1: "12.0005",
        x2: "1.69506",
        y2: "12.0005",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#FFE000"
        }), _jsx("stop", {
          offset: "0.4087",
          stopColor: "#FFBD00"
        }), _jsx("stop", {
          offset: "0.7754",
          stopColor: "#FFA500"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#FF9C00"
        })]
      })), _jsxs("linearGradient", __assign({
        id: "paint2_linear_3678_152",
        x1: "15.5097",
        y1: "14.1416",
        x2: "-5.71903",
        y2: "34.8329",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#FF3A44"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#C31162"
        })]
      })), _jsxs("linearGradient", __assign({
        id: "paint3_linear_3678_152",
        x1: "-0.433294",
        y1: "-6.49844",
        x2: "9.04621",
        y2: "2.74106",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#32A071"
        }), _jsx("stop", {
          offset: "0.0685",
          stopColor: "#2DA771"
        }), _jsx("stop", {
          offset: "0.4762",
          stopColor: "#15CF74"
        }), _jsx("stop", {
          offset: "0.8009",
          stopColor: "#06E775"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#00F076"
        })]
      })), _jsxs("linearGradient", __assign({
        id: "paint4_linear_3678_152",
        x1: "23.7017",
        y1: "12.0494",
        x2: "1.69542",
        y2: "12.0494",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#CCB300"
        }), _jsx("stop", {
          offset: "0.4087",
          stopColor: "#CC9700"
        }), _jsx("stop", {
          offset: "0.7754",
          stopColor: "#CC8400"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#CC7D00"
        })]
      })), _jsxs("linearGradient", __assign({
        id: "paint5_linear_3678_152",
        x1: "15.5096",
        y1: "14.1416",
        x2: "-5.71916",
        y2: "34.8329",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#CC2E36"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#9C0E4E"
        })]
      })), _jsxs("linearGradient", __assign({
        id: "paint6_linear_3678_152",
        x1: "12.7565",
        y1: "1.46417",
        x2: "-2.89814",
        y2: "16.7224",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#008DE0"
        }), _jsx("stop", {
          offset: "0.00657445",
          stopColor: "#008DE0"
        }), _jsx("stop", {
          offset: "0.2601",
          stopColor: "#00A7E0"
        }), _jsx("stop", {
          offset: "0.5122",
          stopColor: "#00B8E0"
        }), _jsx("stop", {
          offset: "0.7604",
          stopColor: "#00C4E0"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#00C7E0"
        })]
      })), _jsxs("linearGradient", __assign({
        id: "paint7_linear_3678_152",
        x1: "15.6851",
        y1: "14.258",
        x2: "-5.29028",
        y2: "35.2336",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#E0333C"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#AB0F56"
        })]
      })), _jsxs("linearGradient", __assign({
        id: "paint8_linear_3678_152",
        x1: "23.7016",
        y1: "12.0005",
        x2: "1.69507",
        y2: "12.0005",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#E0C500"
        }), _jsx("stop", {
          offset: "0.4087",
          stopColor: "#E0A600"
        }), _jsx("stop", {
          offset: "0.7754",
          stopColor: "#E09100"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#E08900"
        })]
      })), _jsxs("linearGradient", __assign({
        id: "paint9_linear_3678_152",
        x1: "23.7015",
        y1: "12.0004",
        x2: "1.69494",
        y2: "12.0004",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#FFE840"
        }), _jsx("stop", {
          offset: "0.4087",
          stopColor: "#FFCE40"
        }), _jsx("stop", {
          offset: "0.7754",
          stopColor: "#FFBC40"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#FFB540"
        })]
      })), _jsxs("linearGradient", __assign({
        id: "paint10_linear_3678_152",
        x1: "12.7564",
        y1: "1.46421",
        x2: "-2.89814",
        y2: "16.7224",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#40B8FF"
        }), _jsx("stop", {
          offset: "0.00657445",
          stopColor: "#40B9FF"
        }), _jsx("stop", {
          offset: "0.2601",
          stopColor: "#40CEFF"
        }), _jsx("stop", {
          offset: "0.5122",
          stopColor: "#40DDFF"
        }), _jsx("stop", {
          offset: "0.7604",
          stopColor: "#40E7FF"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#40EAFF"
        })]
      })), _jsxs("linearGradient", __assign({
        id: "paint11_linear_3678_152",
        x1: "-0.433217",
        y1: "-6.4984",
        x2: "9.04629",
        y2: "2.7411",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx("stop", {
          stopColor: "#65B895"
        }), _jsx("stop", {
          offset: "0.0685",
          stopColor: "#62BD95"
        }), _jsx("stop", {
          offset: "0.4762",
          stopColor: "#50DB97"
        }), _jsx("stop", {
          offset: "0.8009",
          stopColor: "#44ED98"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#40F498"
        })]
      }))]
    })]
  }));
};

export default GooglePlaySmall;